// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Menu_menuWrapper__A3qzo","menu":"Menu_menu__JC+xS","collapsed":"Menu_collapsed__9cyRZ"};